// Dictionnaire des pages « calculateur brut → net par CP », FR + NL (R8).
// Même principe que app/baremes/_i18n.js : un seul gabarit sert les deux
// langues, pour qu'elles ne puissent pas diverger.
export const T = {
  fr: {
    code: 'fr-BE', locale: 'fr-BE', cp: 'CP', racine: '/calculateur',
    filAriane: 'Calculateurs par CP',
    badge: 'Calcul gratuit',
    h1: (key, nom) => `Calcul du salaire net en CP ${key} — ${nom}`,
    chapo: (nom) =>
      `Du brut au net pour un travailleur du secteur « ${nom} », avec le coût employeur complet. Calculé par le moteur de paie d'Aureus Social Pro, pas par une formule approchée.`,
    hypotheses: 'Hypothèses : isolé, sans enfant à charge, temps plein. Changez le brut ou le statut pour recalculer.',
    sourceOk: '✓ Minimum sectoriel officiel',
    verifieLe: (d) => `vérifié le ${d}`,
    h2Grille: 'Du minimum sectoriel vers le haut',
    sousGrille: 'Trois niveaux calculés à partir du minimum d\'entrée de la commission paritaire.',
    colBrut: 'Brut mensuel', colNet: 'Net estimé', colCout: 'Coût employeur',
    h2Detail: 'Le détail du calcul',
    lBrut: 'Salaire brut', lOnss: 'Cotisation ONSS travailleur', lBonus: 'Bonus à l\'emploi',
    lImposable: 'Revenu imposable', lPP: 'Précompte professionnel',
    lCsss: 'Cotisation spéciale sécurité sociale', lNet: 'Salaire net',
    lCout: 'Coût total employeur', lFonds: '+ fonds sectoriel', lPension: '+ pension sectorielle (2e pilier)',
    h2Statut: 'Ouvrier ou employé : ce que ça change',
    statutTexte: (key) =>
      `Le statut n'est pas une case à cocher : il découle de l'arrêté royal qui institue la commission paritaire ${key}. Nous ne l'affirmons donc pas à votre place — mais la différence est réelle, car la base de cotisation d'un ouvrier est portée à 108 %.`,
    statutEmploye: 'Employé', statutOuvrier: 'Ouvrier',
    ecartNet: 'Écart de net à brut égal', ecartCout: 'Écart de coût employeur',
    h2Faq: (key) => `Questions fréquentes — CP ${key}`,
    ctaH2: (key) => `Éditez la vraie fiche de paie en CP ${key}`,
    ctaTexte: 'Aureus Social Pro applique le barème sectoriel à jour et génère la fiche complète — ONSS, précompte, primes, Dimona et DmfA comprises.',
    ctaBouton: 'Nous contacter →', ctaLien: '/contact',
    versBareme: (key) => `← Voir le barème complet de la CP ${key}`,
    retour: '← Tous les calculateurs par commission paritaire',
    // Maillage latéral (25/08/2026) — même motif que côté barèmes, voir
    // app/lib/cp-liees.js. Le gabarit calculateur avait le même défaut : ses
    // 121 pages recevaient 2 liens internes chacune.
    h2Liees: 'Calculateurs des commissions paritaires liées',
    motifs: {
      mere: 'commission mère',
      'sous-commission': 'sous-commission',
      soeur: 'même commission mère',
    },
    versJumelle: 'Deze berekening in het Nederlands →',
    avertissement:
      'Estimation indicative. Le net réel dépend aussi de votre situation familiale, de vos enfants à charge, de votre régime de travail et de vos avantages extra-légaux.',
  },
  nl: {
    code: 'nl-BE', locale: 'nl-BE', cp: 'PC', racine: '/berekening',
    filAriane: 'Berekeningen per PC',
    badge: 'Gratis berekening',
    h1: (key, nom) => `Nettoloon berekenen in PC ${key} — ${nom}`,
    chapo: (nom) =>
      `Van bruto naar netto voor een werknemer in de sector « ${nom} », met de volledige werkgeverskost. Berekend door de loonmotor van Aureus Social Pro, niet door een benaderende formule.`,
    hypotheses: 'Uitgangspunten: alleenstaande, zonder kinderen ten laste, voltijds. Wijzig het brutoloon of het statuut om opnieuw te berekenen.',
    sourceOk: '✓ Officieel sectoraal minimum',
    verifieLe: (d) => `gecontroleerd op ${d}`,
    h2Grille: 'Vanaf het sectorale minimum',
    sousGrille: 'Drie niveaus berekend vanaf het instapminimum van het paritair comité.',
    colBrut: 'Bruto per maand', colNet: 'Geschat netto', colCout: 'Werkgeverskost',
    h2Detail: 'De berekening in detail',
    lBrut: 'Brutoloon', lOnss: 'RSZ-bijdrage werknemer', lBonus: 'Werkbonus',
    lImposable: 'Belastbaar inkomen', lPP: 'Bedrijfsvoorheffing',
    lCsss: 'Bijzondere bijdrage sociale zekerheid', lNet: 'Nettoloon',
    lCout: 'Totale werkgeverskost', lFonds: '+ sectoraal fonds', lPension: '+ sectoraal pensioen (2e pijler)',
    h2Statut: 'Arbeider of bediende: wat het verandert',
    statutTexte: (key) =>
      `Het statuut is geen keuzevakje: het volgt uit het koninklijk besluit dat paritair comité ${key} opricht. Wij beweren het dus niet in uw plaats — maar het verschil is reëel, want de bijdragebasis van een arbeider wordt op 108 % gebracht.`,
    statutEmploye: 'Bediende', statutOuvrier: 'Arbeider',
    ecartNet: 'Verschil in netto bij gelijk bruto', ecartCout: 'Verschil in werkgeverskost',
    h2Faq: (key) => `Veelgestelde vragen — PC ${key}`,
    ctaH2: (key) => `Maak de echte loonfiche in PC ${key}`,
    ctaTexte: 'Aureus Social Pro past het actuele sectorale barema toe en genereert de volledige loonfiche — RSZ, bedrijfsvoorheffing, premies, Dimona en DmfA inbegrepen.',
    ctaBouton: 'Contacteer ons →', ctaLien: '/contact',
    versBareme: (key) => `← Bekijk het volledige barema van PC ${key}`,
    retour: '← Alle berekeningen per paritair comité',
    h2Liees: 'Berekeningen van verwante paritaire comités',
    motifs: {
      mere: 'moedercomité',
      'sous-commission': 'subcomité',
      soeur: 'zelfde moedercomité',
    },
    versJumelle: 'Ce calculateur en français →',
    avertissement:
      'Indicatieve schatting. Het werkelijke nettoloon hangt ook af van uw gezinssituatie, kinderen ten laste, arbeidsregime en extralegale voordelen.',
  },
};

export const euro = (n, lang) =>
  n == null ? '—' : Number(n).toLocaleString(lang === 'nl' ? 'nl-BE' : 'fr-BE',
    { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';

export const slugCalc = (key, lang) =>
  (lang === 'nl' ? 'pc-' : 'cp-') + String(key).replace(/\./g, '-');

export const urlCalc = (key, lang) =>
  `https://www.aureussocial.be${T[lang].racine}/${slugCalc(key, lang)}`;
